import React, { useContext, useState, useEffect, useLayoutEffect } from "react";
import HeroSection from "../components/HeroSection";
import MeetOurPartners from "../components/MeetPartners";
import Course from "../components/course";
import CollegeCollab2 from "../components/CollegeCollab2";
import Internship from "../components/Internship";
import Masterclass from "../components/Masterclass";
import MoreQueries from "../components/MoreQueries";
import { ModalContext } from "../Context/ModalContext";
import Student from "../componentsofcourse/Student";
import Mentors from "../componentsofcourse/Mentors";
import Awards from "../components/Awards";
import PressRecognition from "../components/PressRecognition";
import MeetPartners2 from "../components/MeetPartners2";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
function Home() {
	let { open, update_status } = useContext(ModalContext);
	const [modal, setModal] = useState(false);
	console.log(open);

	useEffect(() => {
		update_status(!open);
		setModal(true);
	}, [modal]);

	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});

	useEffect(() => {
		// check if user is logged in
		const token = localStorage.getItem("token");
		if (token) {
			window.location.href = "/superAdmin";
		} else {
			window.location.href = "/signin";
		}
	}, []);
	return (
		<>
			<Navbar />
			<div style={{ overflowX: "hidden" }}>
				<HeroSection />
				<MeetPartners2 />
				<MeetOurPartners />
				<Course />
				<CollegeCollab2 />
				<Internship />
				<Student />
				<Mentors />
				<Awards />
				<PressRecognition />
				<Masterclass />
				<MoreQueries />
				<Footer />
				{/* <Projects />

                        <College />
                        <Programs sadfas/> */}
			</div>
		</>
	);
}
export default Home;
